gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


const body = document.querySelector('body');
const pageWrapper = body.querySelector('.page-wrapper');

//header 
const header = document.querySelector('header');
const headerWrapMobile = header.querySelector('.header-wrap__mobile');
const mobileMenuHandler = header.querySelector('.mobile-menu__handler');


mobileMenuHandler.addEventListener('click', () => {
    headerWrapMobile.classList.toggle('active');
    mobileMenuHandler.classList.toggle('active');
});

//modal sites
const modalsitesHandler = document.querySelectorAll('.modalsites');
const modalsitesWrapper = document.querySelector('.modalsites-wrapper');
const closeModale = document.querySelectorAll('.close-modale');

modalsitesHandler.forEach(handler => {
    handler.addEventListener('click', () => {
        modalsitesWrapper.classList.add('active');
        body.style.overflow = 'hidden';
    });
});

closeModale.forEach(close => {
    close.addEventListener('click', () => {
        modalsitesWrapper.classList.remove('active');
        body.style.overflow = '';
    });
});

// header scroll behavior
let lastScrollTop = 0;
const scrollThreshold = 20;

window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (Math.abs(scrollTop - lastScrollTop) < scrollThreshold) {
        return;
    }
    
    if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
        header.classList.add('header-hidden');
    } else {
        header.classList.remove('header-hidden');
    }
    
    lastScrollTop = scrollTop;
});
